import React from 'react';
import _ from "lodash";

import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import AutoComplete from 'material-ui/AutoComplete';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import { orange500 } from 'material-ui/styles/colors';

import { getNationalities } from '../../../../services/nationalities';

const styles = {
    button: orange500,
};

class Nationalities extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            query: '',
            nationality: null, // The nationality represented by the query
            dataSource: [],
            anchorEl: null,
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.menuItems = this.menuItems.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleOpen(e) {
        e.preventDefault();

        this.setState({
            open: true,
            anchorEl: e.currentTarget,
        });
    }

    handleClose() {
        this.setState({
            open: false,
        });
    }

    handleRemove(id) {
        const value = _.cloneDeep(this.props.value);
        const index = value.findIndex(item => item.id === id);
        if (index < 0) return;
        value.splice(index, 1);
        this.props.changeField({
            field: 'nationalities',
            value,
        });
    }

    handleAdd() {
        const { nationality } = this.state;
        
        if (!nationality) return;

        const { value } = this.props;
        if (value.findIndex(n => n.id === nationality.id) < 0) {
            this.props.changeField({
                field: 'nationalities',
                value: [
                    ..._.cloneDeep(value),
                    _.omit(nationality, ['name']),
                ],
            });
        }

        this.setState({
            query: '',
            nationality: null,
            dataSource: [],
        });
    }

    menuItems(nationalities) {
        return nationalities.map(item => (
          <MenuItem
            key={item.id}
            value={item.id}
            primaryText={item.names.join(' / ')}
            rightIcon={
                <ContentRemoveIcon 
                    onClick={() => this.handleRemove(item.id)}
                    color='red'
                />
            }
          />
        ));
    }

    handleSearch(query) {
        this.setState({ query });

        getNationalities(query)
            .then(({ errors, data }) => {
                if (errors.length) return;
                this.setState({
                    dataSource: data.map(item => ({
                        ...item,
                        name: item.names.join(' / '),
                    })),
                });
            });
    }

    handleChange(nationality) {
        this.setState({ nationality });
    }

    render() {
        const { open, query, dataSource, anchorEl } = this.state;
        const { confirmed, modifiedFields, value } = this.props;

        return (
            <React.Fragment>
                <div className='col-xs-3'>
                    <AutoComplete
                        name='query'
                        floatingLabelText='Officers / Crew'
                        disabled={confirmed}
                        searchText={query}
                        dataSource={dataSource}
                        dataSourceConfig={{ text: 'name', value: 'id' }}
                        onUpdateInput={this.handleSearch}
                        onNewRequest={this.handleChange}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                        popoverProps={{ canAutoPosition: true }}
                        fullWidth
                    />
                </div>
                <div className='col-xs-1'>
                    <IconButton onClick={this.handleAdd} style={{ margin: '20px 0 0' }}>
                        <ContentAddIcon color='green' />
                    </IconButton>
                </div>
                <div className='col-xs-3' style={{ margin: '28px 0 0 0' }}>
                    <RaisedButton 
                        onClick={this.handleOpen}
                        label='Nationality'
                        labelStyle={{ fontSize: '13px' }}
                        disabled={!value.length}
                        backgroundColor={modifiedFields && modifiedFields.includes('nationalities') ? styles.button : null}
                    />
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onRequestClose={this.handleClose}
                    >
                        <Menu>
                            {
                                this.menuItems(value)
                            }
                        </Menu>
                    </Popover>
                </div>
            </React.Fragment>
        );
    }
}

export default Nationalities;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Nationalities.jsx